<button mat-raised-button aria-label="Language selection" [matMenuTriggerFor]="menu" color="primary">
  {{current.title}} <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item *ngFor="let lang of languages" (click)="onSelect(lang)">{{lang.title}}</button>
</mat-menu>
